import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ShadowEvent, TableCssClassName as ClassName } from '../types';
import { tableInsertColumnButtonSize } from '../ui/consts';
import { updateShadowListForStickyStyles } from './update-overflow-shadows';
export var OverflowShadowsObserver = /*#__PURE__*/function () {
  // updateShadowState is a method to update shadow key
  function OverflowShadowsObserver(updateShadowState, _table, wrapper) {
    var _this = this;
    _classCallCheck(this, OverflowShadowsObserver);
    _defineProperty(this, "firstCell", null);
    _defineProperty(this, "lastCell", null);
    _defineProperty(this, "getFirstCell", function (isSticky, hasHeaderRow) {
      var _this$table;
      return (_this$table = _this.table) === null || _this$table === void 0 ? void 0 : _this$table.querySelector(isSticky || !hasHeaderRow ? 'table tbody tr td' : 'table tbody tr th');
    });
    _defineProperty(this, "getLastCell", function (isSticky, hasHeaderRow) {
      var _this$table2;
      return (_this$table2 = _this.table) === null || _this$table2 === void 0 ? void 0 : _this$table2.querySelector(isSticky || !hasHeaderRow ? 'table tbody tr td:last-child' : 'table tbody tr th:last-child');
    });
    _defineProperty(this, "isSticky", false);
    _defineProperty(this, "stickyRowHeight", 0);
    _defineProperty(this, "init", function () {
      var table = _this.table;
      if (!_this.wrapper || !table) {
        return;
      }
      if (!_this.tableIntersectionObserver) {
        var intersectonOnbserverCallback = function intersectonOnbserverCallback(entry) {
          var _entry$rootBounds, _entry$rootBounds2;
          if (!((_entry$rootBounds = entry.rootBounds) !== null && _entry$rootBounds !== void 0 && _entry$rootBounds.height) && !((_entry$rootBounds2 = entry.rootBounds) !== null && _entry$rootBounds2 !== void 0 && _entry$rootBounds2.width)) {
            return;
          }
          if (entry.target !== _this.firstCell && entry.target !== _this.lastCell) {
            return;
          }
          _this.updateStickyShadowsHeightIfChanged();
          _this.checkIntersectionEvent(entry, _this.firstCell === entry.target ? ShadowEvent.SHOW_BEFORE_SHADOW : ShadowEvent.SHOW_AFTER_SHADOW);
        };
        _this.tableIntersectionObserver = new IntersectionObserver(function (entries, _) {
          entries.forEach(function (entry) {
            return intersectonOnbserverCallback(entry);
          });
        }, {
          threshold: [0, 1],
          root: _this.wrapper,
          rootMargin: "0px ".concat(tableInsertColumnButtonSize / 2, "px 0px 0px")
        });
        return;
      }
    });
    _defineProperty(this, "checkIntersectionEvent", function (entry, shadowKey) {
      if (
      // If it's in full view, don't show shadow.
      entry.isIntersecting && entry.intersectionRatio === 1) {
        _this.updateShadowState(shadowKey, false);
      } else if (
      // If it's in partial view, show a shadow
      entry.intersectionRatio < 1) {
        _this.updateShadowState(shadowKey, true);
      }
    });
    _defineProperty(this, "observeCells", function (isSticky, hasHeaderRow) {
      var stickyChanged = !!isSticky !== _this.isSticky;
      _this.isSticky = !!isSticky;

      // update sticky shadows
      _this.updateStickyShadowsHeightIfChanged();
      if (!stickyChanged) {
        var firstCell = _this.getFirstCell(isSticky, hasHeaderRow);
        var lastCell = _this.getLastCell(isSticky, hasHeaderRow);
        if (!firstCell || !lastCell || firstCell === _this.firstCell && lastCell === _this.lastCell) {
          return;
        }
      }
      _this.firstCell = _this.getFirstCell(isSticky, hasHeaderRow);
      _this.lastCell = _this.getLastCell(isSticky, hasHeaderRow);
      if (_this.tableIntersectionObserver && _this.firstCell && _this.lastCell) {
        _this.tableIntersectionObserver.disconnect();
        _this.tableIntersectionObserver.observe(_this.firstCell);
        _this.tableIntersectionObserver.observe(_this.lastCell);
      }
    });
    _defineProperty(this, "updateStickyShadows", function (stickyRowHeight) {
      var _this$wrapper, _this$wrapper2, _this$wrapper2$parent, _this$wrapper3, _this$wrapper3$parent;
      if (!_this.isSticky) {
        return;
      }
      var stickyCell = _this.getStickyCell();
      if (!stickyCell || !((_this$wrapper = _this.wrapper) !== null && _this$wrapper !== void 0 && _this$wrapper.parentElement)) {
        return;
      }
      var heightStyleOrCompute = "".concat(stickyRowHeight || stickyCell.clientHeight + 1, "px");
      // Use getElementsByClassName here for a live node list to capture
      // sticky shadows
      var liveRightShadows = (_this$wrapper2 = _this.wrapper) === null || _this$wrapper2 === void 0 ? void 0 : (_this$wrapper2$parent = _this$wrapper2.parentElement) === null || _this$wrapper2$parent === void 0 ? void 0 : _this$wrapper2$parent.getElementsByClassName("".concat(ClassName.TABLE_RIGHT_SHADOW));
      var liveLeftShadows = (_this$wrapper3 = _this.wrapper) === null || _this$wrapper3 === void 0 ? void 0 : (_this$wrapper3$parent = _this$wrapper3.parentElement) === null || _this$wrapper3$parent === void 0 ? void 0 : _this$wrapper3$parent.getElementsByClassName("".concat(ClassName.TABLE_LEFT_SHADOW));
      updateShadowListForStickyStyles(heightStyleOrCompute, liveLeftShadows);
      updateShadowListForStickyStyles(heightStyleOrCompute, liveRightShadows);
    });
    this.updateShadowState = updateShadowState;
    this.table = _table;
    this.wrapper = wrapper;
    this.init();
  }
  _createClass(OverflowShadowsObserver, [{
    key: "updateStickyShadowsHeightIfChanged",
    value: function updateStickyShadowsHeightIfChanged() {
      if (!this.isSticky) {
        return;
      }
      var stickyCell = this.getStickyCell();
      if (!stickyCell) {
        return;
      }
      var newStickyRowHeight = stickyCell.clientHeight + 1;
      if (newStickyRowHeight === this.stickyRowHeight) {
        this.stickyRowHeight = newStickyRowHeight;
        this.updateStickyShadows(this.stickyRowHeight);
      }
    }
  }, {
    key: "getStickyCell",
    value: function getStickyCell() {
      var _this$wrapper4;
      var stickyRow = (_this$wrapper4 = this.wrapper) === null || _this$wrapper4 === void 0 ? void 0 : _this$wrapper4.querySelector('tr.sticky');
      var stickyCell = stickyRow && stickyRow.firstElementChild;
      return stickyCell;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this.tableIntersectionObserver) {
        this.tableIntersectionObserver.disconnect();
        this.tableIntersectionObserver = undefined;
      }
    }
  }]);
  return OverflowShadowsObserver;
}();